import { get } from 'lodash';
import { showModal } from '../../actions/show-modal';
import { SET_IS_LOADED } from '../../actions/set-is-loaded';
import { HIDE_MODAL } from '../../actions/hide-modal';
import { PUB_SUB_CHANNEL_MODAL } from '@wix/communities-blog-client-common';
import { getModalMeta, getModals } from '../../selectors/modal-selectors';
import { isMobile } from '../../services/wix-sdk-utils';

export default ({ createShowMessage, resolvers }) => (store) => {
  const showMessage = createShowMessage(store);

  return (next) => (action) => {
    if (action.type === HIDE_MODAL) {
      const {
        payload: { type, resolve },
      } = action;

      const { focusOnCloseId } = getModalMeta(store.getState(), type);
      if (focusOnCloseId) {
        const element = document.getElementById(focusOnCloseId);
        // without timeout closing modal with Enter will fire key up on focused element
        element && setTimeout(() => element.focus(), 100);
      }

      const resolver = resolvers[type];
      if (resolver && resolve) {
        store.dispatch(
          resolver(resolve, {
            showMessage,
            isMobile: isMobile(),
          }),
        );
      }
    }

    if (action.type === SET_IS_LOADED && get(action, 'payload.isLoaded') && get(action, 'payload.entity') === 'modal') {
      const modal = getModals(store.getState())[0];
      if (modal) {
        store.dispatch(
          showModal(modal, {
            publish: [PUB_SUB_CHANNEL_MODAL],
          }),
        );
      }
    }

    next(action);
  };
};
